import axios from 'utils/bsac-api.js';

const state = {
  courses: [],
};

const getters = {
  /**
   *
   * @param {*} state
   * @returns
   */
  courses: (state) => state.courses,
  /**
   *
   * @param {*} state
   * @param {*} rankId
   * @returns
   */
  courseByRankId: (state) => (rankId) => {
    let returnCourse = null;
    if (rankId === null) return returnCourse;
    state.courses.forEach((course) => {
      if (course.rank_id === rankId) returnCourse = course;
    });
    return returnCourse;
  },
};

const mutations = {
  /**
   * ストアを初期化する
   * @param {*} state
   */
  reset(state) {
    state.courses = [];
  },
  /**
   * ダイブセンターをセットする
   * @param {*} state
   * @param {*} shops
   */
  setCourses(state, courses) {
    state.courses = courses;
    // console.log(JSON.stringify(state.courses));
  },
};

const actions = {
  /**
   * APIを呼び出しeラーニング申込用コース一覧を取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getCoursesForElearningApplication({ commit }) {
    return axios
      .get(process.env.FRONT_URL + '/elearning/courses')
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setCourses', response.data.data);
        return {
          success: true,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
        };
      });
  },
  /**
   * APIを呼び出しコース申込用コース一覧を取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getCoursesForCourseApplication({ commit }) {
    return axios
      .get(process.env.FRONT_URL + '/form/courses')
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setCourses', response.data.data);
        return {
          success: true,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
        };
      });
  },
  /**
   *
   * @param {*} param0
   * @param {*} id
   */
  getCourseByRankId({ getters }, rankId) {
    console.log('rankId:' + rankId);
    let returnCourse = null;
    getters.courses.forEach((course) => {
      console.log('course.rank_id:' + course.rank_id);
      if (course.rank_id === rankId) returnCourse = course;
    });
    console.log('returnCourse:' + JSON.stringify(returnCourse));
    return returnCourse;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
